import { data } from '../../svg/Bolt/data';
import { makeIcon } from '../makeIcon';

export const Bolt = makeIcon(data, 'bolt', 'Bolt');

export default Bolt;
